export const MetaCopy = () => ({
  init() {
    const tagRows = () => {
      const items = [...this.$el.children];
      items.forEach((item, i) => {
        const prev = items[i - 1];
        // A pipe means "same line as the previous item". The pipe is rendered
        // absolutely (out of flow) so toggling it never changes wrapping —
        // that keeps this measurement stable even when items are borderline wide.
        item.toggleAttribute('data-pipe', Boolean(prev) && item.offsetTop === prev.offsetTop);
      });
    };

    tagRows();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(tagRows);

    let lastWidth = 0;
    this._observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const { width } = entry.contentRect;
        if (Math.abs(width - lastWidth) > 1) {
          lastWidth = width;
          tagRows();
        }
      }
    });
    this._observer.observe(this.$el.parentElement);
  },
  destroy() {
    if (this._observer) this._observer.disconnect();
  }
});
